import { login, logout, getInfo, refreshToken } from '@/api/login'
import { getDicts } from "@/api/system/dict/data";
import { getToken, setToken, setExpiresIn, removeToken } from '@/utils/auth'
import { Message } from 'element-ui'
const user = {
  state: {
    token: getToken(),
    access_token: getToken("access-token"),
    // access_token: getToken("access_token"),
    // refresh_token: getToken("refresh_token"),
    name: '',
    avatar: '',
    roles: [],
    permissions: [],
    isSignAgreement: ''
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_EXPIRES_IN: (state, time) => {
      state.expires_in = time
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions
    },
    SET_TOKEN: (state, access_token) => {
      state.access_token = access_token
    },
    SET_TOKEN: (state, refresh_token) => {
      state.refresh_token = refresh_token
    },
    SET_isSignAgreement: (state, isSignAgreement) => {
      state.isSignAgreement = isSignAgreement
    },
    SET_lanList: (state, lanList) => {
      state.lanList = lanList
    },
    SET_userEmail: (state, userEmail) => {
      state.userEmail = userEmail
    },
    SET_contractNo: (state, contractNo) => {
      state.contractNo = contractNo
    },
    SET_userAddress: (state, userAddress) => {
      state.userAddress = userAddress
    },
    SET_userPhone: (state, userPhone) => {
      state.userPhone = userPhone
    },
    SET_enterpriseName: (state, enterpriseName) => {
      state.enterpriseName = enterpriseName
    },
    SET_devRights: (state, devRights) => {
      state.devRights = devRights
    },
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim()
      const password = userInfo.password
      const code = userInfo.code
      const uuid = userInfo.uuid
      return new Promise((resolve, reject) => {
        login(username, password, code, uuid).then(res => {
          if (res.code === 200) {
            let data = res.data
            // setToken(data.access_token)
            // commit('SET_TOKEN', data.access_token)
            setToken(data.access-token)
            commit('SET_TOKEN', data.access-token)
            setExpiresIn(data.expires_in)
            commit('SET_EXPIRES_IN', data.expires_in)
            resolve()
          } else {
            resolve()
            Message.error(res.desc)
          }

        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      // alert(11)
      return new Promise((resolve, reject) => {
        getInfo().then(res => {
          const avatar = res.datas.profile_image == "" ? require("@/assets/images/profile.jpg") : res.datas.profile_image;
          commit('SET_isSignAgreement', res.datas.isSignAgreement)
          commit('SET_contractNo', res.datas.contract_no)
          commit('SET_userAddress', res.datas.user_address)
          commit('SET_userEmail', res.datas.user_email)
          commit('SET_userPhone', res.datas.user_phone)
          commit('SET_enterpriseName', res.datas.enterprise_name)
          commit('SET_devRights', res.datas.devRights)
          commit('SET_AVATAR', avatar)
          // commit('SET_contractNo', "2021100814444444477")
          // commit('SET_userAddress', "江苏南京快回我嗯好违和")
          // commit('SET_userEmail', "527854656@lkw")
          // commit('SET_userPhone', "13585844458")
          // commit('SET_enterpriseName', "百度百科不")
          // window.refresh_public_layout(res.datas.profile_image,res.datas.enterprise_name)
          if (res.datas.dev_type.toString() != '') { // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', res.datas.dev_type)
            commit('SET_PERMISSIONS', res.permissions)
          } else {
            commit('SET_ROLES', ['ROLE_DEFAULT'])
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 刷新token
    RefreshToken({ commit, state }) {
      return new Promise((resolve, reject) => {
        refreshToken(state.token).then(res => {
          setExpiresIn(res.data)
          commit('SET_EXPIRES_IN', res.data)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 退出系统
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then((res) => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          commit('SET_PERMISSIONS', [])
          removeToken()
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    },
    getLanList({ commit }) {
      return new Promise((resolve, reject) => {
        getDicts('lan_type').then((res) => {
          if (res.status === 200) {
            commit('SET_lanList', res.datas)
            resolve()
          }

        })
      })
    }
  }
}

export default user